/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { Box, IconButton, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import AddCategory from "../../Modals/addCategory";
import IosSwitchMain from "../../components/iosSwitchMain";
import AddGroups from "../../Modals/addGroup";
import AddGroup from "../../Modals/addGroup";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate } from "react-router-dom";

const GroupList = () => {
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const navigate = useNavigate()

  const rows = [
    {
      id: 1,
      name: "Experience Type",
    },
    {
      id: 2,
      name: "Dinner",
    },
  ];
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 2,
      minWidth: 50,
      field: "id",
      headerName: "S.No",
      editable: false,
      sortable: false,
    },

    {
      field: "name",
      headerName: "Group Name",
      flex: 2,
      minWidth: 150,
      sortable: false,
      editable: false,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={1} className="cursor_p"  onClick={() => {
          navigate('/manage-groups/tags')
      }}>
          <span>{params.row.name}</span>
          <OpenInNewIcon fontSize="small" />
        </Box>
      ),
    },

    {
      flex: 2,
      minWidth: 150,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: () => {
        return <IosSwitchMain />;
      },
    },

    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton onClick={() => setOpen(true)}>
                <img src="/static/images/edit_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton>
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
        />
      </div>

      <AddGroup open={open} onClose={handleCloseModal} setOpen={setOpen} />
    </>
  );
};

export default GroupList;
